﻿<template>
    <div class="basket-tours ci-list">
        <template v-for="{ key, type, trip, nested } in Display_Rows()" :key="key">
            <!-- group_addons (cart page): a tour's available add-ons, in its subpanel under the tour's added add-ons -->
            <div v-if="type == 'addons'" class="ci-sub-addons">
                <slot name="addons" :trip="trip"></slot>
            </div>
            <article v-else-if="zeroPriceCheck(trip)" :id="'basket_' + trip.tour_id" class="ci" :class="{ 'is-addon': add_on_tour(trip), 'is-nested': nested }">
                <div class="ci-media print:hidden">
                    <img v-if="get_Image(trip.tour_id, 900, 0)" :src="get_Image(trip.tour_id, 900, 0)" :alt="imageAltText(trip.tour_id)">
                </div>

                <div class="ci-body">
                    <div class="ci-top">
                        <div class="ci-heading">
                            <h3 class="ci-title">{{getProductName(trip)}}</h3>
                        </div>
                        <p class="ci-price"><strong>{{get_price(trip)}}</strong> <small>{{get_Currency()}}</small></p>
                    </div>

                    <p v-if="isGiftCard(trip)" class="ci-desc">{{get_Tour_description(trip.tour_id)}}</p>

                    <ul v-if="!add_on_tour(trip) && !isAAT() && !isPaymentLink()" class="ci-route" :hidden="!valid_Times(trip_ends(trip.departure_date, trip.tour_id))">
                        <li>
                            <span class="ci-route-label" :hidden="start_location(trip.tour_id) == null">Starts in {{start_location(trip.tour_id)}}</span>
                            <span class="ci-route-date">{{trip_starts(trip.departure_date, trip.tour_id)}} {{trip_checkintime(trip.tour_id)}}</span>
                        </li>
                        <li :hidden="trip_ends(trip.departure_date, trip.tour_id) == trip_starts(trip.departure_date, trip.tour_id)">
                            <span class="ci-route-label" :hidden="end_location(trip.tour_id) == null">Ends in {{end_location(trip.tour_id)}}</span>
                            <span class="ci-route-date">{{trip_ends(trip.departure_date, trip.tour_id)}}</span>
                        </li>
                    </ul>
                    <ul v-if="!add_on_tour(trip) && !isAAT() && isPaymentLink()" class="ci-route" :hidden="!valid_Times(trip_ends(trip.departure_date, trip.tour_id))">
                        <li>
                            <span class="ci-route-date">Departure: {{trip_starts_date(trip.departure_date)}}</span>
                        </li>
                    </ul>
                    <ul v-if="!add_on_tour(trip) && isAAT()" class="ci-route" :hidden="!valid_Times(trip_ends(trip.departure_date, trip.tour_id))">
                        <li>
                            <span class="ci-route-label" :hidden="start_location(trip.tour_id) == null">Starts in {{start_location(trip.tour_id)}}</span>
                            <span class="ci-route-date">Departure: {{trip_starts_date(trip.departure_date)}} {{trip_checkintime(trip.tour_id)}}</span>
                        </li>
                        <li :hidden="trip_ends(trip.departure_date, trip.tour_id) == trip_starts(trip.departure_date, trip.tour_id)">
                            <span class="ci-route-label" :hidden="end_location(trip.tour_id) == null">Ends in {{end_location(trip.tour_id)}}</span>
                            <span class="ci-route-date">Return: {{trip_ends_date(trip.departure_date, trip.tour_id)}}</span>
                        </li>
                    </ul>

                    <p class="ci-desc" :hidden="!add_on_tour(trip)"><span v-html="FormatDescription(get_Tour_Details(trip.tour_id)?.marketing_information?.description)"></span></p>
 
                    <div class="ci-meta">
                        <!-- add-ons: the date in the pill instead of the Starts/Ends lines above, so the card stays compact -->
                        <span v-if="add_on_tour(trip)" class="ci-chip is-addon-date">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
                            {{ add_on_date(trip) ? "Add-on for " + add_on_date(trip) : "Add-on" }}
                        </span>
                        <span v-if="!add_on_tour(trip) && duration(trip?.tour_id) != '' && valid_Times(trip_ends(trip.departure_date, trip.tour_id)) && (isAAT() || !isPaymentLink())" class="ci-chip">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
                            {{ isAAT() ? duration(trip?.tour_id) : durationInDays(trip?.tour_id) }}
                        </span>
                        <span v-if="!add_on_tour(trip) && is_non_listed_tour(tour_id) && !isGiftCard(trip) && passenger_total(trip?.tour_id) != ''" class="ci-chip">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                            {{passenger_total(trip?.tour_id)}}
                        </span>
                        <span v-else-if="!add_on_tour(trip) && item_total(trip) != ''" class="ci-chip">{{item_total(trip)}}</span>
                        <basket_item :add_on="add_on_tour(trip)" :trip="trip" :parent_tour_id="add_on_parent(trip)"></basket_item>
                    </div>

                    <!-- Was already never shown: is_non_listed_tour() always returns true. -->
                    <div v-if="!is_non_listed_tour(tour_id)" class="ci-links" :hidden="add_on_tour(trip)">
                        <button v-if="!add_on_tour(trip)" type="button" class="ci-link" @click="tour_selected(trip.tour_id)">See full itinerary</button>
                        <button v-if="add_on_tour(trip)" type="button" class="ci-link" @click="tour_selected(trip.tour_id)">See add-on description</button>
                    </div>

                    <div class="ci-actions" :hidden="trip.booking_identifier != null">
                        <button v-if="!add_on_tour(trip)" type="button" class="ci-action" @click="tour_edit(trip?.tour_id)">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" /></svg>
                            Edit tour
                        </button>
                        <button v-if="!deletedTour(trip.tour_id)" type="button" class="ci-action is-danger" @click="Remove_Trip(trip.tour_id)">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /></svg>
                            Remove
                        </button>
                        <button v-else type="button" class="ci-action is-danger" disabled>
                            <svg class="ts-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
                            Removing…
                        </button>
                        <!-- added add-on: confirmation on the right of the actions row -->
                        <span v-if="add_on_tour(trip)" class="ao-added is-compact ci-added">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
                            Added
                        </span>
                    </div>
                </div>
            </article>
        </template>
    </div>
    <div class="slideout" :hidden="isHidden" 
         style="z-index: 201 !important;">
        <div class="slideout-inner">
            <button class="close no-bg" @click="isHidden = true"></button>
            <div class="slideout-content">
                <itinerary :tour_id="tour_id" :banner="true" ref="itinerary" v-if="!isHidden"></itinerary>
            </div>

        </div>

        <div class="slideout-bg" @click="isHidden = true"></div>

    </div>
    <div class="slideout" :hidden="isHidden_Edit_Tour"
         style="z-index: 201 !important;">
        <div class="slideout-inner">
            <button class="close no-bg" @click="isHidden_Edit_Tour = true"></button>
            <p>Tour Details Changes</p>
            <div class="slideout-content">
                <tour_details ref="tour_details" :trip_index="edit_trip_index" @Add_To_Cart="Add_To_Cart"></tour_details>
            </div>
        </div>

        <div class="slideout-bg" @click="isHidden_Edit_Tour = true"></div>

    </div>
</template>

<script lang="ts" src="./basket.ts"></script>